import { render } from "./AboutV2.vue?vue&type=template&id=360f64ad&scoped=true"
import script from "./AboutV2.vue?vue&type=script&lang=js"
export * from "./AboutV2.vue?vue&type=script&lang=js"

import "./AboutV2.vue?vue&type=style&index=0&id=360f64ad&scoped=true&lang=css"

import exportComponent from "C:\\4 Websites\\enfinity\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360f64ad"]])

export default __exports__